import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'aiStatusText',
})
export class AiStatusTextPipe implements PipeTransform {
    transform(status: string): string {
        switch (status) {
            case 'S3':
                return '활성화';
            case 'S1':
                return '비활성화';
            case 'S2':
                return '어드민';
            case 'S0':
                return '활성';
            case 'D2':
                return '활성';
            case 'G3':
                return '비회원';
            default:
                return status;
        }
    }
}

